Object.defineProperty(exports,"__esModule",{value:true});var _platform=require("./../variables/platform");var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var h1Theme={
color:variables.textColor,
fontSize:variables.fontSizeH1,
lineHeight:variables.lineHeightH1};


return h1Theme;
};
//# sourceMappingURL=H1.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/theme/components/H1.js
// module id = 433
// module chunks = 0